var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section section_intro",attrs:{"id":"home"}},[_c('img',{ref:"image",staticClass:"video video_responsive",attrs:{"src":_vm.welcomePosterSrc,"alt":"promo Image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }